import { IAddress, IProfile } from '@jumpstart/core';
import { CountryCode } from '@jumpstart/core/dist/schemas/common/country-code';
import Button from '@mui/material/Button';
import Grid from '@mui/material/Grid';
import React, { useState } from 'react';
import JSONInput from 'react-json-editor-ajrm';
import locale from 'react-json-editor-ajrm/locale/en';
import { ICreateCustomer } from '../services/Customer';
import { JSONInputEvent } from './json-input';

export interface IStripeCustomerJson {
  subscriberProfile: IProfile;

  onSubmit(data: Omit<ICreateCustomer, 'production' | 'profileId'>): void;
}

export default function StripeCustomerJson(props: IStripeCustomerJson) {
  const { subscriberProfile, onSubmit } = props;
  const [data, setData] = useState<null | Omit<ICreateCustomer, 'profileId'>>(null);

  const handleChange = (event: JSONInputEvent) => {
    if (event.error) {
      console.error(event.error);
      setData(null);
    } else if (event.jsObject) {
      setData(event.jsObject);
    }
  };

  return (
    <Grid
      container
      direction="column"
      alignItems="center"
      sx={{
        '& > :not(:last-child)': {
          marginBottom: 4
        }
      }}
    >
      <Grid item>

        <JSONInput
          id={`stripe-form-${subscriberProfile.id}`}
          placeholder={{
            name: `${subscriberProfile.firstName ? subscriberProfile.firstName + ' ' : ''}${subscriberProfile.lastName ? subscriberProfile.lastName : ''}`,
            phone: subscriberProfile.phone,
            email: subscriberProfile.email,
            address: subscriberProfile.address
          }}
          // colors      = { darktheme }
          locale={locale}
          height='380px'
          onChange={handleChange}
        />
      </Grid>
      <Button
        variant="contained"
        size="large"
        disabled={!data}
        onClick={() => {
          if (data) {
            onSubmit(data);
          }
        }}
      >
        Submit
      </Button>
    </Grid>
  );
}
